import { defineStore } from 'pinia'
import packService from '@/services/api/pack.service'

export const usePackStore = defineStore(
    'pack',
    {
        state: () => ({
            packs: [],
            loading: false,
            error: null,
        }),
        getters: {
            purchaseOptions: (state) => {
                if (!state.packs || state.packs.length === 0) return []

                // Find the base price per star (from the smallest pack or use a fixed rate)
                const basePackValue = state.packs.reduce(
                    (min, pack) =>
                        pack.pricePerStar < min.pricePerStar ? pack : min,
                    state.packs[0]
                )
                const basePricePerStar = basePackValue?.pricePerStar || 0.2 // fallback to 20 cents per star

                const options = state.packs.map((pack) => {
                    const savings = basePricePerStar * pack.stars - pack.price
                    const discountPercentage =
                        savings > 0
                            ? Math.round(
                                  (savings / (basePricePerStar * pack.stars)) *
                                      100
                              )
                            : 0

                    return {
                        id: pack._id,
                        amount: pack.stars,
                        price: pack.price,
                        discount: discountPercentage,
                        description: pack.description,
                    }
                })
                return options
            },
        },
        actions: {
            async fetchPacks() {
                if (this.packs.length > 0 || this.loading) {
                    return
                }

                this.loading = true
                this.error = null
                try {
                    const packs = await packService.getActivePacks()
                    if (packs && Array.isArray(packs)) {
                        this.packs = packs
                    }
                } catch (error) {
                    console.error('Error fetching packs:', error)
                    this.error = error
                } finally {
                    this.loading = false
                }
            },
        },
    },
    {
        persist: {
            storage: sessionStorage,
        },
    }
)
